module.exports = __webpack_public_path__ + "img/htly.c467b674.png";